import { render, staticRenderFns } from "./PromoCodeOverview.vue?vue&type=template&id=488f5dab&scoped=true&"
import script from "./PromoCodeOverview.vue?vue&type=script&lang=js&"
export * from "./PromoCodeOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f5dab",
  null
  
)

export default component.exports